import {h} from 'preact';

type ProductImageProps = {
  imageUrl: string;
  width: number;
  height: number;
}

function ProductImage({imageUrl, width, height}: ProductImageProps) {
  return (
    <>
      <div className="kits__table-row-item product-image">
        <div className="kits__table-row-item-img"><img src={imageUrl} width={width} height={height}/></div>
      </div>
    </>
  )
}

export {ProductImage};
